import React from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../Dropdowns/SimpleDropdown';
import { panelsVersionsOptions } from '../../configs/report';

const PanelVersionDropdown = ({ panelVersion, onChange }) => (
  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
    <span className="text-black">Panel Version:</span>
    <SimpleDropdown
      selected={panelVersion}
      variant="light"
      options={panelsVersionsOptions}
      onChange={onChange}
    />
  </div>
);

PanelVersionDropdown.propTypes = {
  panelVersion: T.string.isRequired,
  onChange: T.func.isRequired,
};

export default PanelVersionDropdown;
